module.exports = __webpack_public_path__ + "static/img/service-QA.5addf74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/service-QA.png
// module id = 35bw
// module chunks = 0